export default __webpack_public_path__ + "static/media/f_md-10.f5d86ea0.svg";